import { WizardCompanyFormModel } from '../../../../company/components/wizard-company-form/WizardCompanyForm';
import { legalToWizardCompanyFormModel, wizardCompanyFormModelToLegal } from '../../../../company/components/wizard-company-form/mappers';
import {
  Contact, OfferWizardData, WizardContact,
} from '../../../../providers/api/dtos';

export const toAssignmentWizardSellerModel = (initialData: OfferWizardData) => {
  const contacts: WizardContact[] = initialData.sellerContacts || [];

  const firstLegalContact = contacts.find((contact) => contact.legal !== undefined)?.legal;

  return legalToWizardCompanyFormModel(firstLegalContact);
};

export async function toOfferWizardData(existingData: OfferWizardData, values: WizardCompanyFormModel, updatedContacts: Contact[], isSellerLegalPerson: boolean): Promise<OfferWizardData> {
  const newContacts: WizardContact[] = updatedContacts.map((contact) => {
    const existingContact = existingData.sellerContacts?.find(({ id }) => contact.id === id);

    return {
      ...existingContact,
      id: contact.id,
      legal: undefined,
      overriddenFields: {
        ...existingContact?.overriddenFields,
        name: contact.name,
        phoneNumber: contact.phoneNumber,
        email: contact.email,
        fiscalCode: contact.fiscalCode,
        birthday: contact.birthday,
        birthplace: contact.birthplace,
        residence: contact.residence,
      },
      updatedAt: contact.updatedAt,
    };
  });

  if (isSellerLegalPerson && updatedContacts.length > 0) {
    const legalContact = newContacts[0];

    newContacts[0] = { ...legalContact, legal: wizardCompanyFormModelToLegal(values) };
  }

  return {
    ...existingData,
    isSellerLegalPersonOnly: isSellerLegalPerson,
    sellerContacts: newContacts,
    isDigitallySigned: false,
  };
}
